import { render, staticRenderFns } from "./orderChange.vue?vue&type=template&id=b6624234&scoped=true"
import script from "./orderChange.vue?vue&type=script&lang=js"
export * from "./orderChange.vue?vue&type=script&lang=js"
import style0 from "./orderChange.vue?vue&type=style&index=0&id=b6624234&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6624234",
  null
  
)

export default component.exports